import { ReactNode } from 'react';

import Loading from '../atoms/Loading';
import Tooltip from '../atoms/Tooltip';
import Text from '../base/Text';

export default function GenerationButton({
  children,
  icon,
  progress,
  onClick,
  disabled,
  tooltipText,
}: {
  children?: ReactNode;
  icon?: ReactNode;
  progress?: { percentage: number; statusText: string };
  onClick?: () => void;
  disabled?: boolean;
  tooltipText?: string;
}) {
  return (
    <Tooltip text={tooltipText || ''} disabled={!tooltipText}>
      <button
        className={`border-gray-30 dark:border-gray-60 relative z-0 flex h-[30px] cursor-pointer items-center rounded-lg border transition-all ${
          progress ? '' : 'hover:bg-gray-15 dark:hover:bg-gray-75'
        } ${
          disabled
            ? 'bg-gray-15 dark:bg-gray-75 text-gray-60 dark:text-gray-30 cursor-default'
            : 'dark:bg-gray-90 bg-white dark:text-white'
        }`}
        onClick={progress || disabled ? undefined : onClick}
      >
        {progress ? (
          <>
            <div
              className="absolute bottom-0 left-0 top-0 z-0 transition-all ease-linear"
              style={{
                backgroundColor: 'rgba(101,241,87,0.16)',
                width: `${progress.percentage}%`,
              }}
            />
            <div className="z-1 relative flex items-center gap-2 px-2">
              <Loading className="h-[18px] w-[18px]" />
              <Text variant="studio/body/medium/xs" className="pt-[0.1em]">
                {progress.statusText}
              </Text>
            </div>
          </>
        ) : (
          <div className="flex items-center gap-1 pl-[5px] pr-3">
            {icon}
            <Text variant="studio/body/medium/xs" className="pt-[0.1em]">
              {children}
            </Text>
          </div>
        )}
      </button>
    </Tooltip>
  );
}
